import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Button, ButtonDirective } from "@ankaadia/ankaadia-shared-frontend";
import { PrimeTemplate } from "primeng-v17/api";
import { CardModule } from "primeng-v17/card";
import { OverlayPanelModule } from "primeng-v17/overlaypanel";
import { EscapeButtonDirective } from "../../../shared/directives/escape-button.directive";
import { AppDateTimePipe } from "../../../shared/pipes/date.pipe";
import { AppendToBodyDirective } from "../../../shared/primeng/append-to-body/append-to-body.directive";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { ActivityTableComponent } from "../../activity/activity-table/activity-table.component";
import { NotificationConfigurationComponent } from "../notification-configuration/notification-configuration.component";
import { NewUiNotificationListDialogComponent } from "./new-ui-notification-list-dialog.component";

@Component({
  selector: "app-notification-list-dialog",
  templateUrl: "./notification-list-dialog.component.html",
  styleUrl: "./notification-list-dialog.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateDirective,
    CardModule,
    ButtonDirective,
    ActivityTableComponent,
    OverlayPanelModule,
    AppendToBodyDirective,
    PrimeTemplate,
    NotificationConfigurationComponent,
    Button,
    EscapeButtonDirective,
    AppDateTimePipe,
  ],
})
export class NotificationListDialogComponent extends NewUiNotificationListDialogComponent {}
